// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3_pQB","actionsCol":"EnrolledClinics_actionsCol__2F_gd"};